function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M41.6 14.6L40.3 12C29 12.6 17.6 12.6 6.3 12L5 14.6",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M40.3 12L36.1 3.6C35.5 2.3 34.1 1.5 32.7 1.5H13.9C12.5 1.5 11.1 2.3 10.5 3.6L6.29999 12",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M39.5 10.5H40.8L41.1 9.29997C41.2 8.79997 41.7 8.49997 42.2 8.59997L45.6 9.39997C45.8 9.49997 46 9.59997 46 9.89997V10.7C46 11.4 45.5 11.9 44.8 11.9H40.2",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M7 10.5H5.7L5.4 9.29998C5.3 8.79998 4.8 8.49998 4.3 8.69998L0.9 9.49998C0.7 9.49998 0.5 9.69998 0.5 9.89998V10.7C0.5 11.4 1 12 1.7 12H6.3",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M28.4 12C28.4 10.1 29.9 8.5 31.8 8.5C33.7 8.5 35.3 10 35.3 11.9",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M22.4 1.40002L23.8 4.00002L22.5 5.40002L23.3 7.20002L21.8 9.20002L23.3 10.8L22.4 12.4",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4 8.59998L17.6 6.59998L18.5 7.89998L20.4 7.19998L22.6 8.19998",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M23.3 4.59998L24.9 5.59998L26.6 5.09998L30.5 6.59998L32.9 4.99998",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M17.6 6.60002L16.9 4.60002L14.3 5.10002L12.8 3.40002L9.70001 5.10002",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgIcnCapGlassCrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 16,
    viewBox: "0 0 47 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCapGlassCrack);
export default __webpack_public_path__ + "static/media/icn-cap-glass-crack.b3a8c2f6495e89b5f5f0a7989a959979.svg";
export { ForwardRef as ReactComponent };